import { TextField, Typography, Tabs, Tab, makeStyles, MuiThemeProvider, TableCell, createMuiTheme, Snackbar } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import api from '../api';
import CloseImage from '../../assets/ic_close.png';
import ImageUploader from 'react-images-upload';
import { format } from 'date-fns';
import CustomDate from '../components/customDate';
import CustomTextField from '../components/customTextField';
import EditReservasiCode from './editReservasiCode';
import AddPembayaran from './addPembayaran';
import MUIDataTable from 'mui-datatables';
import editIcon from '../../assets/1@3x.png';
import ListDataPayment from './ListDataPayment';
import AddTagihanResep from './addTagihanResep';
import ListDataRecipe from './ListDataRecipe';
import ListDataLab from './ListDataLab';
import AddTagihanLab from './addTagihanLab';
import ListDataRadiologi from './ListDataRadiologi';
import AddTagihanRadiologi from './addTagihanRadiologi';
import { formatCurrency } from '../../library/Util';
import NumberFormat from 'react-number-format';
import MuiAlert from '@material-ui/lab/Alert';
import AddPasienBaru from './addPasienBaru';
import Loader from 'react-loader-spinner'
import ic_error from '../../assets/ic_exclamation.png';


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

const style = {
    position: "sticky",
    zIndex: 110
};

export default function DetailTagihanNonReservasiLab(props) {
    const classes = useStyles()
    const editorRef = useRef();
    const history = useHistory()
    const location = useLocation()
    const [reservationCode, setReservationCode] = React.useState("")
    const [medicalRecord, setMedicalRecord] = React.useState("")
    const [patientName, setPatientName] = React.useState("")
    const [doctorName, setDoctorName] = React.useState("")
    const [polyclinic, setPolyclinic] = React.useState("")
    const [dateofBirth, setDateofBirth] = React.useState("")
    const [paymentOption, setPaymentOption] = React.useState("")
    const [gender, setGender] = React.useState("")
    const [diskon, setDiskon] = useState(0)
    const [dibayarInstansi, setDibayarInstansi] = useState(0)
    const [dibayarPribadi, setDibayarPribadi] = useState(0)
    const [visibleCreate, setVisibleCreate] = React.useState(false);
    const [value, setValue] = React.useState(0);
    const [visiblePayment, setVisiblePayment] = React.useState(false);
    const [visibleRecipe, setVisibleRecipe] = React.useState(false);
    const [visibleInputPasien, setVisibleInputPasien] = React.useState(false);
    const [visibleLab, setVisibleLab] = React.useState(false);
    const [visibleRadiologi, setVisibleRadiologi] = React.useState(false);
    const [dataPayment, setDataPayment] = useState([])
    const [dataRecipe, setDataRecipe] = useState([])
    const [dataLab, setDataLab] = useState([])
    const [dataRadiologi, setDataRadiologi] = useState([])
    const [loading, setLoading] = useState(false)
    const [total, setTotal] = useState(0)
    const [grandTotal, setGrandTotal] = useState(0)
    const [appointmentId, setAppointmentId] = useState("")
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [tglBerlaku, setTglBerlaku] = useState(null)
    const [pickFarmasi, setPickFarmasi] = useState(null)
    const [pickLab, setPickLab] = useState(null)
    const [pickTypeLab, setPickTypeLab] = useState(null)
    const [pickRadiologi, setPickRadiologi] = useState(null)
    const [pickTypeRadiologi, setPickTypeRadiologi] = useState(null)
    const [categoryInsurance, setCategoryInsurance] = React.useState("")
    const [insurance, setInsurance] = React.useState("")
    const [namaPasienAsuransi, setNamaPasienAsuransi] = React.useState("")
    const [namaPasienBPJS, setNamaPasienBPJS] = React.useState("")
    const [noRujukan, setNoRujukan] = React.useState("")
    const [dateRujukan, setDateRujukan] = React.useState("")
    const [noKartuAsuransi, setNoKartuAsuransi] = React.useState("")
    const [noKartuBPJS, setNoKartuBPJS] = React.useState("")
    const [payloadPasien, setPayloadPasien] = useState(null)
    const [idPasien, setIdPasien] = useState(null)
    const [visibleNoReferensi, setVisibleNoReferensi] = React.useState(false);
    const [typeCode, setTypeCode] = useState(null)


    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    useEffect(() => {
        console.log('tes');
        // if (location.state.data) {
        //     let data = location.state.data
        //     setReservationCode(data.booking_id)
        //     setMedicalRecord(data.patient_medical_record_no === "" ? "-" : data.patient_medical_record_no)
        //     setPatientName(data.patient_name)
        //     setDoctorName(data.doctor_name)
        //     setPolyclinic(data.polyclinic_name)
        //     setDateofBirth(data.patient_date_of_birth)
        //     setPaymentOption(data.payment_option_name)
        //     setAppointmentId(data.appointment_id)
        //     forceUpdate()
        // }
    }, []);

    useEffect(() => {
        let hasil = Number(total) - Number(diskon)
        setGrandTotal(hasil)
        forceUpdate()
    }, [diskon, total])

    const onOpenPayment = () => {
        setVisiblePayment(true);
    };

    const onClose = () => {
        setVisibleCreate(false);
        setVisiblePayment(false);
        setVisibleRecipe(false);
        setVisibleLab(false);
        setVisibleRadiologi(false);
        setVisibleInputPasien(false)
    };

    const handleSave = () => {
        if (payloadPasien !== null) {
            let bill = []
            if (dataPayment.length > 0) {
                dataPayment.map((item) => {
                    // console.log(item);
                    if (item.id !== 2) {
                        item.val.map((i) => {
                            bill.push({
                                "type": `00${item.id}`,
                                "name": i[1],
                                "quantity": i[2],
                                "is_mix": null,
                                "how_to_use": null,
                                "price": i[4],
                                "notes": i[3],
                                "expired_date": null,
                                "medicine_unit": i[7],
                                "facility_id": pickLab && pickLab.id,
                                "sub_facility_code": pickTypeLab && pickTypeLab.code,
                                // "medicine_type": i[8]
                            })

                        })
                    } else {
                        item.val.map((i) => {
                            if (i[5].id === 1) {
                                let detailItem = []
                                i[6].map((items) => {
                                    detailItem.push(items.itemRacikan)
                                })
                                bill.push({
                                    "type": `00${item.id}`,
                                    "name": i[1],
                                    "quantity": i[2],
                                    "is_mix": i[5].id,
                                    "detail_item": detailItem,
                                    "how_to_use": i[3],
                                    "price": i[4],
                                    "notes": i[3],
                                    "expired_date": format(new Date(tglBerlaku), 'yyyy-MM-dd'),
                                    "medicine_unit": i[7],
                                    // "medicine_type": i[8],
                                    "facility_id": pickFarmasi && pickFarmasi.id,

                                })

                            } else {
                                bill.push({
                                    "type": `00${item.id}`,
                                    "name": i[1],
                                    "quantity": i[2],
                                    "is_mix": i[5].id,
                                    "how_to_use": i[3],
                                    "price": i[4],
                                    "notes": i[3],
                                    "expired_date": format(new Date(tglBerlaku), 'yyyy-MM-dd'),
                                    "medicine_unit": i[7],
                                    // "medicine_type": i[8],
                                    "facility_id": pickFarmasi && pickFarmasi.id,
                                })
                            }
                        })
                    }
                })
            }

            let payload = {
                "is_appointment": 0,
                "total_price": total,
                "paid": dibayarInstansi === "" ? 0 : dibayarInstansi,
                "unpaid": dibayarPribadi === "" ? 0 : dibayarPribadi,
                "discount": diskon === "" ? 0 : diskon,
                "bill": bill
            }
            // console.log(payloadPasien);
            if (payloadPasien.payment.id === 1 && payloadPasien.manual) {
                payload = {
                    ...payload,
                    "patient_name": payloadPasien.name,
                    "patient_dob": payloadPasien.dob,
                    "patient_rm_no": payloadPasien.noRM,
                    "patient_gender": payloadPasien.gender,
                    "payment_option": payloadPasien.payment.id,
                    "doctor_detail_id": payloadPasien.doctor.doctor_detail_id,
                }

            } else if (payloadPasien.payment.id === 1 && !payloadPasien.manual) {
                payload = {
                    ...payload,
                    "patient_id": payloadPasien.idPasien,
                    "payment_option": payloadPasien.payment.id,
                    "doctor_detail_id": payloadPasien.doctor.doctor_detail_id,
                }
            } else if (payloadPasien.payment.id === 2 && payloadPasien.manual) {
                payload = {
                    ...payload,
                    "patient_name": payloadPasien.name,
                    "patient_dob": payloadPasien.dob,
                    "patient_rm_no": payloadPasien.noRM,
                    "patient_gender": payloadPasien.gender,
                    "payment_option": payloadPasien.payment.id,
                    "insurance_id": payloadPasien.asuransi.id,
                    "card_no": payloadPasien.noKartuAsuransi,
                    "card_name": payloadPasien.namaPasienAsuransi,
                    "doctor_detail_id": payloadPasien.doctor.doctor_detail_id,
                }
            } else if (payloadPasien.payment.id === 2 && !payloadPasien.manual) {
                payload = {
                    ...payload,
                    "patient_id": payloadPasien.idPasien,
                    "payment_option": payloadPasien.payment.id,
                    "insurance_id": payloadPasien.asuransi.id,
                    "card_no": payloadPasien.noKartuAsuransi,
                    "card_name": payloadPasien.namaPasienAsuransi,
                    "doctor_detail_id": payloadPasien.doctor.doctor_detail_id,
                }
            } else if (payloadPasien.payment.id === 3 && payloadPasien.manual) {
                payload = {
                    ...payload,
                    "patient_name": payloadPasien.name,
                    "patient_dob": payloadPasien.dob,
                    "patient_rm_no": payloadPasien.noRM,
                    "patient_gender": payloadPasien.gender,
                    "payment_option": payloadPasien.payment.id,
                    "reference_no": payloadPasien.noRujukan,
                    "reference_date": payloadPasien.dateRujukan,
                    "card_no": payloadPasien.noKartuBPJS,
                    "card_name": payloadPasien.namaPasienBPJS,
                    "doctor_detail_id": payloadPasien.doctor.doctor_detail_id,
                }
            } else if (payloadPasien.payment.id === 3 && !payloadPasien.manual) {
                payload = {
                    ...payload,
                    "patient_id": payloadPasien.idPasien,
                    "payment_option": payloadPasien.payment.id,
                    "reference_no": payloadPasien.noRujukan,
                    "reference_date": payloadPasien.dateRujukan,
                    "card_no": payloadPasien.noKartuBPJS,
                    "card_name": payloadPasien.namaPasienBPJS,
                    "doctor_detail_id": payloadPasien.doctor.doctor_detail_id,
                }
            }
            // console.log(JSON.stringify(payload));

            api.create().createBill(payload).then(response => {
                // console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        let data = response.data.data
                        if (data.bill_details.length > 0) {
                            data.bill_details.map((item) => {
                                setTypeCode(item.type_code)
                            })
                        }
                        setVisibleNoReferensi(true)
                    } else {
                        if (response.data.data) {
                            setOpenAlert(true)
                            setMessageAlert(JSON.stringify(response.data.data))
                            setStatusAlert("Warning")
                        }
                    }
                }
                setLoading(false)
            })

        } else {
            alert("Data pasien wajib diisi !\nInputkan data pasien terlebih dahulu.")
            setLoading(false)
        }
    }

    const setData = (payload) => {
        // console.log(payload);
        let data = payload
        // console.log(data);
        setReservationCode(data.booking_id)
        setMedicalRecord(data.patient_medical_record_no)
        setPatientName(data.patient_name)
        setDoctorName(data.doctor_name)
        setPolyclinic(data.polyclinic_name)
        setDateofBirth(data.patient_date_of_birth)
        setPaymentOption(data.payment_option_name)
        forceUpdate()
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const onSubmitPayment = (payload) => {
        setLoading(true)
        let data = [
            payload.pickType.id,
            payload.pickType.name,
            payload.keterangan,
            payload.qty,
            payload.keteranganTambahan,
            payload.amount,
            payload.isMix,
            payload.dataRacikan,
            payload.satuanObat,
            payload.totalAmount

        ]
        let idx = dataPayment.findIndex((val) => val.id === payload.pickType.id)
        // console.log(idx);
        if (idx > -1) {
            let idxVal = dataPayment.findIndex((val) => val.id === data[0])
            // console.log(idxVal);
            dataPayment[idx].val.push([
                data[1],
                data[2],
                data[3],
                data[4],
                data[5],
                data[6],
                data[7],
                data[8],
                data[9]
            ])
        } else {
            dataPayment.push({
                id: data[0],
                name: data[1],
                val: [[
                    data[1],
                    data[2],
                    data[3],
                    data[4],
                    data[5],
                    data[6],
                    data[7],
                    data[8],
                    data[9]
                ]]
            })
        }
        // console.log(dataPayment);
        setVisiblePayment(false)
        forceUpdate()
        getTotal()
    }

    const deletePayment = (item, index, idx) => {
        setLoading(true)
        if (item.val.length === 1) {
            dataPayment.splice(index, 1)
        } else {
            dataPayment[index].val.splice(idx, 1)
        }
        getTotal()
        forceUpdate()
    }

    const onSubmitRecipe = (payload) => {
        setLoading(true)
        let data = [
            payload.item,
            payload.qty,
            payload.pemakaian,
            payload.pickRacikan.id,
            payload.pickRacikan.name,
            payload.amount,
            payload.totalAmount,
            payload.satuanObat,
            payload.pickMedType.id,
            payload.pickMedType.name,


        ]
        dataRecipe.push(data)
        // console.log(dataRecipe);
        setVisibleRecipe(false)
        forceUpdate()
        getTotal()
    }

    const deleteRecipe = (item, index) => {
        // console.log(dataPayment, item);
        let idxObt = dataPayment.findIndex((val) => val.id === 2)
        let idxArr = dataPayment[idxObt].val.findIndex((val) => val[1] === item[0])
        if (idxArr > -1) {
            dataPayment[idxObt].val.splice(idxArr, 1)
        }
        dataRecipe.splice(index, 1)
        setLoading(true)
        getTotal()
    }

    const onSubmitLab = (payload) => {
        setLoading(true)
        let data = [
            payload.keterangan,
            payload.qty,
            payload.amount,
            payload.totalAmount,
        ]
        dataLab.push(data)
        // console.log(dataLab);
        setVisibleLab(false)
        forceUpdate()
        getTotal()
    }

    const deleteLab = (item, index) => {
        // console.log(dataPayment, item);
        let idxLab = dataPayment.findIndex((val) => val.id === 4)
        let idxArr = dataPayment[idxLab].val.findIndex((val) => val[1] === item[0])
        if (idxArr > -1) {
            dataPayment[idxLab].val.splice(idxArr, 1)
        }
        dataLab.splice(index, 1)
        setLoading(true)
        getTotal()
    }

    const onSubmitRadiologi = (payload) => {
        setLoading(true)
        let data = [
            payload.keterangan,
            payload.qty,
            payload.amount,
            payload.totalAmount,
        ]
        dataRadiologi.push(data)
        // console.log(dataRadiologi);
        setVisibleRadiologi(false)
        forceUpdate()
        getTotal()
    }

    const onSubmitPayload = (payload) => {
        console.log(payload);
        setIdPasien(payload.idPasien)
        setMedicalRecord(payload.noRM)
        setPatientName(payload.name)
        setGender(payload.gender)
        payload.doctor && setDoctorName(payload.doctor.name)
        payload.poli && setPolyclinic(payload.poli.name)
        setDateofBirth(payload.dob)
        setPaymentOption(payload.payment?.id)
        setCategoryInsurance(payload.kategori?.type)
        setInsurance(payload.asuransi?.id)
        setNoRujukan(payload.noRujukan)
        setDateRujukan(payload.dateRujukan)
        setNoKartuAsuransi(payload.noKartuAsuransi)
        setNoKartuBPJS(payload.noKartuBPJS)
        setNamaPasienAsuransi(payload.namaPasienAsuransi)
        setNamaPasienBPJS(payload.namaPasienBPJS)
        setPayloadPasien(payload)
        setVisibleInputPasien(false)
    }


    const deleteRadiologi = (item, index) => {
        // console.log(dataPayment, item);
        let idxRadiologi = dataPayment.findIndex((val) => val.id === 5)
        let idxArr = dataPayment[idxRadiologi].val.findIndex((val) => val[1] === item[0])
        if (idxArr > -1) {
            dataPayment[idxRadiologi].val.splice(idxArr, 1)
        }
        dataRadiologi.splice(index, 1)
        setLoading(true)
        getTotal()
    }

    useEffect(() => {
        getTotal()
    }, [dataRecipe, dataPayment, dataLab, dataRadiologi])

    const getTotal = () => {
        let total = 0
        if (dataPayment.length > 0) {
            dataPayment.map((item) => {
                item.val && item.val.map((i) => {
                    let sum = Number(i[4]) * Number(i[2])
                    if (item.id !== 2 && item.id !== 4 && item.id !== 5) {
                        total += sum
                    } else {
                        total += Number(i[8])
                    }
                })
            })
            // } else if (dataRecipe.length > 0) {
            //     dataRecipe.map((item) => {
            //         total += Number(item[6])
            //     })
        }
        setTotal(total)
        setTimeout(() => {
            setLoading(false)
        }, 500);
        forceUpdate()
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ maxHeight: props.height - 80, width: '100%', overflow: 'scroll', padding: '35px 0px' }}>
            {loading && (loadingComponent)}
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 16 }}>
                <Typography>Data Pasien</Typography>
                <div>
                    <Typography style={{ borderBottom: '1px solid #0066ff', color: '#0066ff', cursor: 'pointer', fontSize: 13, }}
                        onClick={() => setVisibleInputPasien(true)}
                    >Input Data Pasien</Typography>
                </div>
            </div>
            <div style={{ borderBottom: '2px solid #878787' }}>
                <div style={{ padding: '10px 15px', width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <div className="column-1" style={{ width: '10%' }}>
                        <div className="" style={{ width: '100%' }}>
                            <TextField
                                // disabled
                                style={{ width: '85%' }}
                                id="code"
                                name="code"
                                label="Kode Reservasi"
                                value={reservationCode === "" ? "-" : reservationCode}
                                placeholder={"Input Kode Reservasi"}
                                onChange={(e) => {
                                    setReservationCode(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 13,
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-2" style={{ width: '11%' }}>
                        <div className="" style={{ width: '100%' }}>
                            <TextField
                                // disabled
                                style={{ width: '85%' }}
                                id="noRM"
                                name="noRM"
                                label="No. Rekam Medis"
                                value={medicalRecord === "" ? "-" : medicalRecord}
                                placeholder={"Input No. Rekam Medis"}
                                onChange={(e) => {
                                    setMedicalRecord(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 13,
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-3" style={{ width: '18%' }}>
                        <div className="" style={{ width: '100%' }}>
                            <TextField
                                // disabled
                                style={{ width: '85%' }}
                                id="patient"
                                name="patient"
                                label="Nama Pasien"
                                value={patientName === "" ? "-" : patientName}
                                placeholder={"Input Nama Pasien"}
                                onChange={(e) => {
                                    setPatientName(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 13,
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-4" style={{ width: '15%' }}>
                        <div className="" style={{ width: '100%' }}>
                            <TextField
                                // disabled
                                style={{ width: '85%' }}
                                id="gender"
                                name="gender"
                                label="Jenis Kelamin"
                                value={gender === "P" ? "Perempuan" : gender === "L" ? "Laki-laki" : "-"}
                                onChange={(e) => {
                                    setPatientName(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 13,
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-1" style={{ width: '20%' }}>
                        <div className="" style={{ width: '100%' }}>
                            <TextField
                                // disabled
                                style={{ width: '85%' }}
                                id="doctor"
                                name="doctor"
                                label="Nama Dokter"
                                value={doctorName === "" ? "-" : doctorName}
                                placeholder={"Input Nama Dokter"}
                                onChange={(e) => {
                                    setDoctorName(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 13,
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-2" style={{}}>
                        <div className="" style={{ width: '100%' }}>
                            <TextField
                                // disabled
                                style={{ width: '85%' }}
                                id="polyclinic"
                                name="polyclinic"
                                label="Poliklinik"
                                value={polyclinic === "" ? "-" : polyclinic}
                                placeholder={"Input Poliklinik"}
                                onChange={(e) => {
                                    setPolyclinic(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 13,
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-3" style={{ width: '10%' }}>
                        <div className="" style={{ width: '100%' }}>
                            <TextField
                                // disabled
                                style={{ width: '85%' }}
                                id="dateBirth"
                                name="dateBirth"
                                label="Tanggal Lahir"
                                value={dateofBirth === "" ? "-" : format(new Date(dateofBirth), 'dd MMM yyyy')}
                                placeholder={"Input Tanggal Lahir"}
                                onChange={(e) => {
                                    setDateofBirth(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 13,
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-4" style={{ width: '12%' }}>
                        <div className="" style={{ width: '100%' }}>
                            <TextField
                                // disabled
                                style={{ width: '85%' }}
                                id="paymentOpt"
                                name="paymentOpt"
                                label="Opsi Pembayaran"
                                value={paymentOption === 1 ? 'UMUM' : paymentOption === 2 ? 'JAMINAN' : paymentOption === 3 ? 'BPJS' : '-'}
                                placeholder={"Input Opsi Pembayaran"}
                                onChange={(e) => {
                                    setPaymentOption(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 13,
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 16, marginTop: 20, position: 'relative' }}>
                <Typography>Detail Tagihan</Typography>
                <div style={{ position: 'absolute', right: 0, top: '5vh', zIndex: 1000 }}>
                    {value === 0 ?
                        <div onClick={() => onOpenPayment()}>
                            <Typography style={{ borderBottom: '1px solid #0066ff', color: '#0066ff', cursor: 'pointer', fontSize: 13, }}
                            >Tambah Pembayaran</Typography>
                        </div>
                        // :
                        // value === 1 ?
                        //     <div onClick={() => setVisibleRecipe(true)}>
                        //         <Typography style={{ borderBottom: '1px solid #0066ff', color: '#0066ff', cursor: 'pointer', fontSize: 13, }}
                        //         >Tambah Obat</Typography>
                        //     </div>
                        :
                        value === 1 ?
                            <div onClick={() => setVisibleLab(true)}>
                                <Typography style={{ borderBottom: '1px solid #0066ff', color: '#0066ff', cursor: 'pointer', fontSize: 13, }}
                                >Tambah Tagihan Laboratorium</Typography>
                            </div>
                            // :
                            // value === 3 ?
                            //     <div onClick={() => setVisibleRadiologi(true)}>
                            //         <Typography style={{ borderBottom: '1px solid #0066ff', color: '#0066ff', cursor: 'pointer', fontSize: 13, }}
                            //         >Tambah Tagihan Radiologi</Typography>
                            //     </div>
                            :
                            null
                    }
                </div>
            </div>
            <div style={{ marginTop: 10 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="#2a9c6c"
                    classes={{ indicator: classes.tabsIndicator }}
                >
                    <Tab label="Pembayaran" style={{ color: value === 0 ? '#2a9c6c' : 'black' }} />
                    {/* <Tab label="Resep" style={{ color: value === 1 ? '#2a9c6c' : 'black' }} /> */}
                    <Tab label="Laboratorium" style={{ color: value === 1 ? '#2a9c6c' : 'black' }} />
                    {/* <Tab label="Radiologi" style={{ color: value === 3 ? '#2a9c6c' : 'black' }} /> */}
                </Tabs>
                {value === 0 ?
                    !loading && (
                        <div style={{ marginTop: 20 }}>
                            <ListDataPayment
                                data={dataPayment}
                                deletePayment={(item, index, idx) => deletePayment(item, index, idx)}
                                total={total}
                            />
                        </div>
                    )
                    // :
                    // value === 1 ?
                    //     !loading && (
                    //         <div style={{ marginTop: 20 }}>
                    //             <ListDataRecipe
                    //                 data={dataRecipe}
                    //                 deleteRecipe={(item, index, idx) => deleteRecipe(item, index)}
                    //                 setTglBerlaku={(param) => setTglBerlaku(param)}
                    //                 setPickFarmasi={(param) => setPickFarmasi(param)}
                    //                 pickFarmasi={pickFarmasi}
                    //                 total={total}
                    //             />
                    //         </div>
                    //     )
                    :
                    value === 1 ?
                        !loading && (
                            <div style={{ marginTop: 20 }}>
                                <ListDataLab
                                    data={dataLab}
                                    deleteLab={(item, index, idx) => deleteLab(item, index)}
                                    setPickTypeLab={(param) => setPickTypeLab(param)}
                                    pickTypeLab={pickTypeLab}
                                    setPickLab={(param) => setPickLab(param)}
                                    pickLab={pickLab}
                                    total={total}
                                />
                            </div>
                        )
                        // :
                        // value === 3 ?
                        //     !loading && (
                        //         <div style={{ marginTop: 20 }}>
                        //             <ListDataRadiologi
                        //                 data={dataRadiologi}
                        //                 deleteRadiologi={(item, index, idx) => deleteRadiologi(item, index)}
                        //                 setPickTypeRadiologi={(param) => setPickTypeRadiologi(param)}
                        //                 pickTypeRadiologi={pickTypeRadiologi}
                        //                 setPickRadiologi={(param) => setPickRadiologi(param)}
                        //                 pickRadiologi={pickRadiologi}
                        //                 total={total}
                        //             />
                        //         </div>
                        //     )
                        :
                        null
                }
            </div>
            <div style={{ padding: 20, boxShadow: '0 4px 12px 0 #d2d2d2', margin: '20px 10px', borderRadius: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography style={{ color: '#a4a4a4', fontWeight: '300', fontSize: 14 }}>Total Sebelum Diskon</Typography>
                    <Typography style={{ color: '#000000', fontWeight: '300', fontSize: 14 }}>Rp. {formatCurrency(total)}</Typography>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                    <Typography style={{ color: '#a4a4a4', fontWeight: '300', fontSize: 14 }}>Diskon</Typography>
                    <TextField
                        value={diskon}
                        onChange={(e) => {
                            setDiskon(e.target.value)
                            forceUpdate()
                        }}
                        style={{ width: '10%' }}
                        inputProps={{
                            style: {
                                fontSize: 13,
                                textAlign: 'right'
                            }
                        }}
                        InputProps={{
                            inputComponent: NumberFormatCustom,
                        }}
                        InputLabelProps={{
                            style: {
                                fontSize: 14,
                                color: '#7e8085',
                            }
                        }}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, borderBottom: '2px #cecece solid', paddingBottom: 10, }}>
                    <Typography style={{ color: '#278863', fontWeight: '500', fontSize: 16 }}>Total Biaya Tagihan</Typography>
                    <Typography style={{ color: '#278863', fontWeight: '500', fontSize: 16 }}>Rp. {formatCurrency(grandTotal)}</Typography>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                    <Typography style={{ color: 'black', fontSize: 12 }}>Dibayarkan Instansi (Jika Opsi Pembayaran Jaminan/BPJS)</Typography>
                    <TextField
                        value={dibayarInstansi}
                        onChange={(e) => {
                            setDibayarInstansi(e.target.value)
                            forceUpdate()
                        }}
                        style={{ width: '10%' }}
                        inputProps={{
                            style: {
                                fontSize: 13,
                                textAlign: 'right'
                            }
                        }}
                        InputProps={{
                            inputComponent: NumberFormatCustom,
                        }}
                        InputLabelProps={{
                            style: {
                                fontSize: 14,
                                color: '#7e8085',
                            }
                        }}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                    <Typography style={{ color: 'black', fontSize: 12 }}>Dibayarkan Pribadi</Typography>
                    <TextField
                        value={dibayarPribadi}
                        onChange={(e) => {
                            setDibayarPribadi(e.target.value)
                            forceUpdate()
                        }}
                        style={{ width: '10%' }}
                        inputProps={{
                            style: {
                                fontSize: 13,
                                textAlign: 'right'
                            }
                        }}
                        InputProps={{
                            inputComponent: NumberFormatCustom,
                        }}
                        InputLabelProps={{
                            style: {
                                fontSize: 14,
                                color: '#7e8085',
                            }
                        }}
                    />
                </div>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 60 }}>
                <div
                    onClick={() => history.goBack()}
                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                </div>
                <div
                    style={{ backgroundColor: '#2a9c6c', width: 120, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                    onClick={() => {
                        setLoading(true)
                        handleSave()
                        // console.log(content);
                        // console.log(String(content).indexOf("*"));
                    }}>
                    <Typography style={{ color: 'white' }}>Simpan</Typography>
                </div>
            </div>

            {visibleCreate && (
                <EditReservasiCode
                    onClose={onClose}
                    intent="detail"
                    setData={(payload) => setData(payload)}
                // getData={getDataDokter}
                />
            )}
            {visiblePayment && (
                <AddPembayaran
                    onClose={onClose}
                    onSubmit={(payload) => onSubmitPayment(payload)}
                // getData={getDataDokter}
                />
            )}

            {/* {visibleRecipe && (
                <AddTagihanResep
                    onClose={onClose}
                    onSubmit={(payload) => onSubmitRecipe(payload)}
                    onSubmitPayment={(payload) => onSubmitPayment(payload)}
                // getData={getDataDokter}
                />
            )} */}
            {visibleLab && (
                <AddTagihanLab
                    onClose={onClose}
                    onSubmit={(payload) => onSubmitLab(payload)}
                    onSubmitPayment={(payload) => onSubmitPayment(payload)}
                // getData={getDataDokter}
                />
            )}
            {/* {visibleRadiologi && (
                <AddTagihanRadiologi
                    onClose={onClose}
                    onSubmit={(payload) => onSubmitRadiologi(payload)}
                    onSubmitPayment={(payload) => onSubmitPayment(payload)}
                // getData={getDataDokter}
                />
            )} */}
            {visibleInputPasien && (
                <AddPasienBaru
                    onClose={onClose}
                    onSubmit={(payload) => onSubmitPayload(payload)}
                />
            )}

            {visibleNoReferensi && (
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: '#f8fdff', height: '35vh', width: '65vh', display: 'grid' }}>
                        <div style={{ margin: 'auto' }}>
                            <div style={{ width: 90, height: 90, borderRadius: 70, backgroundColor: '#34b68b', border: '3px solid #b3fde4', placeContent: 'center' }}>
                                {/* <img src={circle} style={{width: 100, height: 100}}/> */}
                                <img src={ic_error} style={{ width: 60, height: 60, marginTop: 10 }} />
                            </div>
                        </div>
                        <div>
                            <Typography style={{ fontStyle: 'bold', letterSpacing: 1.5, fontSize: 25, color: '#2a9c6c', fontFamily: 'Poppins' }}>Pembuatan Tagihan Berhasil</Typography>
                        </div>
                        <div>
                            <Typography style={{ fontSize: 18 }}>Nomor Referensi Laboratorium : <b>{typeCode}</b></Typography>
                        </div>
                        <div style={{ margin: 'auto', width: '55%', display: 'flex', justifyContent: 'space-evenly', }}>

                            <div onClick={() => history.goBack()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}